import Repository from "./repository"

export default {
  /**
   * アカウント作成情報登録
   * @params  パラメータ
   * @returns response
   */
  add(params) {
    return Repository.post("/api/s209-create-account/add", params);
  },
  /**
   * アカウント作成チェック
   * @params パラメータ
   * @returns response
   */
  check(params) {
    return Repository.post("/api/s209-create-account/check", params);
  },
  /**
   * アカウント作成実行
   * @params  トークン
   * @returns response
   */
  create(token) {
    return Repository.post("/api/s209-create-account/create", {token})
  }
}